import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useEffect, useMemo} from 'react';
import {useIsQuickView} from '../../QuickView/useIsQuickView';
import {useLinksSection, useSizesSection} from '../../useGetProductBulkSection';

const FEMALE_TOPS_CATEGORY_ID = '517223';
const MALE_SHIRTS_CATEGORY_ID = '20324';

export const useInlineSizeSelectionQuickViewAB = () => {
  const {isActive, activateAbTest} = useIsFeatureActive(
    'show_inline_size_quick_view',
  );

  const {data: linkSection} = useLinksSection(!isActive);
  const {data: sizeSelectionResponse} = useSizesSection({disabled: !isActive});
  const isQuickView = useIsQuickView();

  const isRightCategory = linkSection
    ? Boolean(
        linkSection?.breadcrumbs.find(
          item =>
            item.url.url.includes(FEMALE_TOPS_CATEGORY_ID) ||
            item.url.url.includes(MALE_SHIRTS_CATEGORY_ID),
        ),
      )
    : true;

  useEffect(() => {
    if (isRightCategory && isQuickView) {
      activateAbTest();
    }
  }, [activateAbTest, isRightCategory, isQuickView]);

  // There are some super big labels for sizes, if that is the case and we get one of those
  // we dont want to show our AB tests in those situations as its looking weird
  const isSizeLabelLarger = useMemo(() => {
    if (!sizeSelectionResponse) {
      return false;
    }
    let sizes: SizeSelection_Size[] = [];

    const sizeSelection = sizeSelectionResponse.sizeSelection;
    switch (sizeSelection.type?.$case) {
      case 'sizes':
        sizes = sizeSelection.type.sizes.sizes;
        break;
      case 'groupedSizes':
        if (
          sizeSelection.type.groupedSizes.groups[0]?.content?.$case ===
          'sizeRuns'
        ) {
          sizes =
            sizeSelection.type.groupedSizes.groups[0]?.content.sizeRuns
              .sizeRuns[0]?.sizes || [];
        } else {
          sizes =
            sizeSelection.type.groupedSizes.groups[0]?.content?.sizes.sizes ||
            [];
        }
        break;
      case 'sizeRuns':
        sizes = sizeSelection.type.sizeRuns.sizeRuns[0]?.sizes || [];
        break;
      case 'inlineSelection':
        sizes = sizeSelection.type.inlineSelection.sizes;
        break;
    }

    if (!sizes.length) {
      return false;
    }

    return Boolean(sizes.find(item => item.label.length > 6));
  }, [sizeSelectionResponse]);

  return isActive && isRightCategory && isQuickView && !isSizeLabelLarger;
};
